<template>
    <div class="app">
        <form class="login-form" action="" v-on:submit="modifyLogin">
            <div class="form-line">
                <input type="text" class="gwi-ipt" id="phone-input-new" placeholder="请输入新手机号码" v-model="param.mobileNo" maxlength="11">
            </div>
            <verify-code  v-model="verifyCode" namespace="ConfirmPhone" url="/app/user/send" :param="param" ></verify-code>
            <div style="padding: 0.75rem 0.5rem;">
                <button class="btn-ok phone-input-save" type="submit" >确认修改</button>
            </div>
        </form>
    </div>
</template>
<script>
    import VerifyCode from '../../components/VerifyCode'
    import utils from 'utils'

    module.exports = {
        data: function() {
            return {
                verifyCode: '',
                param: {
                    mobileNo: "",
                    //1：注册/登录  2：修改密码  3：修改手机号
                    operateType:'3',
                }
            }
        },
        components: {
            VerifyCode
        },
        methods: {
            modifyLogin: function($event) {
                $event.preventDefault();
                var checkMsg = utils.verifyNo().butVerifyNo(this);
                if (checkMsg) {
                    return this.$utils.alert(checkMsg);
                }
                this.$http.post('/app/user/mobile', {
                    mobileNo:this.param.mobileNo,
                    verifyCode:this.verifyCode
                }).then(res => {
                    var data = res.body;
                    if (data.resultCode === this.constant.RESULT_SUCCESS) {
                        localStorage.setItem('tokenId', data.data.tokenId);
                        sessionStorage.setItem('tokenId', data.data.tokenId);
                        http.headers.common['tokenId'] = data.data.tokenId;
                        localStorage.setItem('mobileNo', this.param.mobileNo);
                        this.$router.replace('personal')
                    } else {
                        this.$utils.alert(data.resultMsg)
                    }
                })
                return false;
            }
        }
    }
</script>
<style>
    .moblieNo{
        line-height: 40px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// ConfirmPhone.vue?f9669cae